import format from "date-fns/format";

export default date => {
  return format(new Date(date), "HH:mm");
};


// WEBPACK FOOTER //
// ./src/common/filters/date/time.filter.js